import React from 'react'
import { ReactComponent } from './download-csv.svg'
import { MergeReactElementProps } from '../types'

interface SaveCSVProps {
  color?: string
}

type Props = MergeReactElementProps<'svg', SaveCSVProps>

export const SaveCSV = React.forwardRef(
  (props: Props, ref: React.Ref<SVGSVGElement>) => {
    const { color = 'white' } = props
    return <ReactComponent stroke={color} fill='none' ref={ref} {...props} />
  }
)
